<!-- 子菜单 -->
<template>
  <el-sub-menu
    v-if="hasRight"
    class="st-sub-menu"
    :index="subMenuId"
    :popper-offset="0"
  >
    <template #title>{{ label }}</template>
    <slot />
  </el-sub-menu>
</template>

<script setup lang="ts">
/**
 * ### 子菜单容器
 * <warning> 配合 cmd-menu-item一起使用
 */
import { VNode, useSlots } from 'vue';
import { ElSubMenu } from 'element-plus';
import { canAccess } from '../../core/CmdRightsControl';
import { random, isObject } from 'lodash-es';

defineProps<{
  /**
   * ### 子菜单容器名称
   */
  label: string;
}>();

const subMenuId = 'btn-submenu-' + random(1, 10000000);

// 判断是否有可访问的(有权限的)子菜单
function hasAccessableChildren(children: VNode[] | null) {
  if (!children || !children.length) return false;

  for (const node of children) {
    if (!isObject(node.type)) continue;

    if (node.children) {
      if (hasAccessableChildren(node.children as VNode[])) {
        return true;
      }
    } else if (node.props && canAccess(node.props.require as string)) {
      return true;
    }
  }

  return false;
}

const slots = useSlots();
const defaultSoltVNodes = slots.default?.() ?? [];
const hasRight = hasAccessableChildren(defaultSoltVNodes);
</script>

<style lang="scss">
.st-sub-menu .el-sub-menu__title:hover {
  background-color: var(--el-menu-hover-bg-color) !important;
}

.st-sub-menu.is-opened .el-sub-menu__title {
  background-color: var(--el-menu-hover-bg-color) !important;
}
</style>
